<style>
    .v-user-settings-menu .v-user-settings-menu-item {
        cursor: pointer;
    }

    .v-user-settings-menu .v-user-settings-menu-item:hover {
        background-color: #efefef;
    }
</style>


<template>
    <div class="animated fadeIn v-user-settings-menu">
        <b-row>
            <b-col lg="3" md="4">
                <div @click="gotoSetting(Core.Definition.getDefinition('notifications-automatiques'))" class="card v-user-settings-menu-item">
                    <div class="card-body">
                        <div class="text-muted text-right mb-4">
                            <i class="fa fa-commenting font-2xl"></i>
                        </div>
                        <h5>{{Core.Definition.getDefinition('Notifications automatiques')}}</h5>
                        <small>{{Core.Definition.getDefinition('SMS et courriel ...')}}</small>
                    </div>
                </div>
            </b-col>

            <b-col lg="3" md="4">
                <div @click="gotoSetting(Core.Definition.getDefinition('services-externes'))" class="card v-user-settings-menu-item">
                    <div class="card-body">
                        <div class="text-muted text-right mb-4">
                            <i class="fa fa-link font-2xl"></i>
                        </div>
                        <h5>{{Core.Definition.getDefinition('Services externes')}}</h5>
                        <small>{{Core.Definition.getDefinition('Autorisation Google Calendar API ...')}}</small>
                    </div>
                </div>
            </b-col>

            <b-col lg="3" md="4">
                <div @click="gotoSetting(Core.Definition.getDefinition('moyens-de-paiements'))" class="card v-user-settings-menu-item">
                    <div class="card-body">
                        <div class="text-muted text-right mb-4">
                            <i class="fa fa-credit-card font-2xl"></i>
                        </div>
                        <h5>{{Core.Definition.getDefinition('Moyens de paiements')}}</h5>
                        <small>{{Core.Definition.getDefinition('Carte de crédit ...')}}</small>
                    </div>
                </div>
            </b-col>

        </b-row>

    </div>
</template>

<script>
    import Vue from 'vue'
    Vue.use(require('vue-moment'))

    export default {
        name: 'UserSettingsMenu',
        components: {
        },
        watch: {
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core
            }
        },
        computed: {
        },
        methods: {
            gotoSetting(setting) {
                if (this.$route.params.id !== undefined) {
                    let userId = this.$route.params.id
                    this.$router.push(Core.Text.format(Core.Definition.getDefinition('/systeme/utilisateurs/{0}/{1}'),userId, setting))
                } else {
                    this.$router.push(Core.Text.format(Core.Definition.getDefinition('/compte/profil/{0}'), setting))
                }
            }
        }
    }
</script>
